import {
  AfterViewInit,
  Component,
  HostListener,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";

import { RouterModule } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { TranslateModule } from "@ngx-translate/core";
import { Title } from "@angular/platform-browser";
import { SimpleNotificationsModule } from "angular2-notifications";
import { environment } from "../environments/environment";
import { SharedService } from "src/app/_shared/shared.service";
import { RightMenuComponent } from "./SayTS/comps/right-menu/right-menu.component";
import { HeaderComponent } from "./header/header.component";
import { ThemeService } from "./_services/theme.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  imports: [
    RouterModule,
    TranslateModule,
    SimpleNotificationsModule,
    RightMenuComponent,
    HeaderComponent,
  ],
})
export class AppComponent implements AfterViewInit {
  @ViewChild("modalContainer", { static: false, read: ViewContainerRef })
  modalContainer: ViewContainerRef;

  constructor(
    public shared: SharedService,
    private translate: TranslateService,
    private titleService: Title,
    // Injektáž stačí — konstruktor služby aplikuje uložený motiv (i na loginu).
    private themeService: ThemeService,
  ) {
    shared.setTranslate(this.translate);

    if (environment.production) {
      console.log = function () {};
    } else {
      console.log("THIS IS DEV");
    }
  }

  ngAfterViewInit(): void {
    this.shared.setVcr(this.modalContainer);
  }

  /**
   * `isMobileConst` depends only on the viewport width, so refresh it on resize
   * (the initial value comes from the SharedService constructor). It used to be
   * reassigned in `ngAfterViewChecked`, which threw NG0100 in dev mode whenever
   * a scrollbar nudged `innerWidth` across the mobile breakpoint between the
   * main and verification change-detection passes.
   */
  @HostListener("window:resize")
  onResize(): void {
    this.shared.isMobileConst = this.shared.isMobile();
  }
}
